import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { UpdateAdvisorField } from "data/advisor/actions";

export function useDispatchUserSubscription() {
  const dispatch = useDispatch();

  return useCallback(
    (subscriptionResult) => {
      const a = UpdateAdvisorField({
        subscriptionConfirmation:
          subscriptionResult.createSubscription.successMessage,
      });
      dispatch(a);

      return a;
    },
    [dispatch]
  );
}

export default useDispatchUserSubscription;
